/**
 * v-hasPermi · 功能权限按钮级控制
 * ------------------------------------------------------------
 * 用法：v-hasPermi="'user.create'" 或 v-hasPermi="['user.edit','user.create']"（任一命中）。
 * 当前用户 perms 含 '*'（超管）或指定权限点时保留元素，否则从 DOM 移除。
 * 仅作界面收敛；服务端仍逐端点鉴权，前端隐藏不代替后端校验。
 */
import type { Directive } from 'vue'
import { authUser } from '@/data/api/auth-store'

function allowed(value: string | string[]): boolean {
  const perms = authUser.value?.perms ?? []
  if (perms.includes('*')) return true
  const need = Array.isArray(value) ? value : [value]
  return need.some(p => perms.includes(p))
}

function apply(el: HTMLElement, value: string | string[]): void {
  if (!allowed(value)) el.parentNode?.removeChild(el)
}

export const hasPermi: Directive<HTMLElement, string | string[]> = {
  mounted: (el, binding) => apply(el, binding.value),
  updated: (el, binding) => apply(el, binding.value)
}
